<template>
  <div id="direction-icon">
    <Icon
      type="md-navigate"
      :style="{ transform: 'rotate(' + (direction * 45-45) + 'deg)' }"
    />{{ utils.direction(direction) }}
  </div>
</template>
<script>
export default {
  props: ["direction"],
};
</script>
<style lang="">
#direction-icon i {
  font-size: 16px;
  color: #189ad6;
  margin-right: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/Direction.vue